import { colors } from '@constants/colors';

export const useStyles = () => {
  return {
    root: {
      height: '29px',
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,

      '& img, & .MuiAvatar-root': {
        width: 24,
        height: 24,
        fontSize: 12,
      },
    },
    label: {
      fontSize: 14,
      fontWeight: 500,
      color: colors.white,

      '&::first-letter': {
        textTransform: 'uppercase',
      },
    },
  };
};
